import { useCallback, useMemo } from "react";
import { NotificationBannerItem } from "../NotificationBanner";
import useMissedPaymentAlert from "./useMissedPaymentAlert";
import useRenewSoonAlert from "./RenewSoonAlert";
import useExpiringDocumentsAlert from "./ExpiringDocumentsAlert";
import useCashbackAlert from "./useCashbackAlert";
import useAccountReviewAlert from "./useAccountReviewAlert";

const sortAlerts = (a: NotificationBannerItem, b: NotificationBannerItem) => {
  const priority = { red: 3, amber: 2, green: 1 };
  return (priority[b.status ?? 'green'] ?? 0) -
         (priority[a.status ?? 'green'] ?? 0);
}

export type AlertResult = NotificationBannerItem | NotificationBannerItem[] | null;

const useAllAlerts = () => {
  const missed = useMissedPaymentAlert();
  const renew = useRenewSoonAlert();
  const documents = useExpiringDocumentsAlert(); // { alerts, refresh }
  const cashback = useCashbackAlert();
  const review = useAccountReviewAlert();

  const alerts = useMemo(
    () =>
      [
        ...(missed.alerts ?? []),
        ...(renew.alerts ?? []),
        ...(documents.alerts ?? []),
        ...(cashback.alerts ?? []),
        ...(review.alerts ?? []),
      ].sort(sortAlerts),
    [missed.alerts, renew.alerts, documents.alerts, cashback.alerts, review.alerts]
  );

  const refreshAll = useCallback(() => {
    documents.refresh?.();
    renew.refresh?.()
    review.refresh?.()
    cashback.refresh?.()
    missed.refresh?.()
  }, [documents.refresh, renew.refresh, review.refresh, cashback.refresh, missed.refresh]);

  return { alerts, refreshAll };
};

export default useAllAlerts;